import { useAuth } from '../../context/AuthContext';
import styles from './TopBar.module.css';

const POLICY_LABELS = {
  FCFS:       'First-Come',
  POINTS:     'Points',
  RANDOMIZED: 'Random',
};

export default function TopBar({
  session,
  waitingCount,
  isPaused,
  isLocked,
  policy,
  onToggleSidePanel,
  sidePanelOpen,
}) {
  const { logout } = useAuth();

  return (
    <div className={styles.bar}>

      <button
        className={styles.menuBtn}
        onClick={onToggleSidePanel}
        title={sidePanelOpen ? 'Hide panel' : 'Show panel'}
      >
        <span /><span /><span />
      </button>

      <div className={styles.logo}>
        Gradiance<span className={styles.dot}>.</span>
      </div>

      <div className={styles.divider} />

      {session ? (
        <>
          <div className={styles.pill}>
            <span className={styles.pillDot} />
            Session {session.display_label ? session.display_label : `#${session.session_id}`}
          </div>

          <div className={styles.stat}>
            <span className={styles.statNum}>{waitingCount}</span>
            <span className={styles.statLabel}>waiting</span>
          </div>

          <div className={`badge badge-waiting ${styles.policyBadge}`}>
            {POLICY_LABELS[policy] || policy}
          </div>

          {isPaused && (
            <div className="badge badge-paused">Paused</div>
          )}

          {isLocked && (
            <div className={styles.lockIcon} title="Swaps locked">🔒</div>
          )}
        </>
      ) : (
        <span className={styles.noSession}>No active session</span>
      )}

      <button
        className="btn-ghost"
        onClick={logout}
        style={{ marginLeft: 'auto', fontSize: 12, padding: '5px 10px' }}
      >
        Sign out
      </button>

    </div>
  );
}